import { render } from "./InsertLayoutButton.vue?vue&type=template&id=826e2056&scoped=true"
import script from "./InsertLayoutButton.vue?vue&type=script&lang=js"
export * from "./InsertLayoutButton.vue?vue&type=script&lang=js"

import "./InsertLayoutButton.vue?vue&type=style&index=0&id=826e2056&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826e2056"]])

export default __exports__